import axios from "@/plugins/axios"
const project = {
  state: {
    projectDic: {},
  },
  mutations: {
    SET_PROJECTDIC: (state, data) => {
      state.projectDic = data
    },
  },
  actions: {
    addprojectDic({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        axios({
          url: "/project/get/roleTeam",
          method: "get",
          headers: {
            "Content-Type": "application/json",
          },
        }).then((res) => {
          resolve(res.data)
          commit("SET_PROJECTDIC", {
            ...state.projectDic,
            负责的团队: [
              {
                label: "不限",
                value: null,
              },
              ...(res.data || []),
            ],
          })
        }).catch(error => reject(error))

        axios({
            url: '/setting/get/team',
            method: 'get',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(res => {
            commit("SET_PROJECTDIC", {
                ...state.projectDic,
                '支持的团队': [

            {
                label: '不限',
                value: null
            },
            ...(res.data?.map(it => ({label: it.value, value: it.value})) || [])
                ]
            })
        })
      })
    },
  },
}

export default project
